"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _immutable = require("immutable");

var _ProfileObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ProfileObjectTypesType"));

var EngagementAssociationActions = _interopRequireWildcard(require("crm_ui/engagementAssociations/actions/EngagementAssociationActions"));

var _EngagementAssociationsStore = _interopRequireDefault(require("crm_ui/engagementAssociations/EngagementAssociationsStore"));

var _DefaultAssociationsDependency = _interopRequireDefault(require("crm_ui/engagementAssociations/dependencies/DefaultAssociationsDependency"));

var _generalStore = require("general-store");

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _InteractionRecord = _interopRequireDefault(require("customer-data-objects/interaction/InteractionRecord"));

var _LocalInteraction = _interopRequireDefault(require("customer-data-communicator/schema/communicator/interaction/local/LocalInteraction"));

var _Interactions = require("customer-data-communicator/schema/communicator/interaction/Interactions");

var _InteractionDescriptorRecord = _interopRequireDefault(require("customer-data-communicator/schema/communicator/interaction/config/InteractionDescriptorRecord"));

var dependencies = {
  associationsMap: {
    stores: [_EngagementAssociationsStore.default],
    deref: function deref(props) {
      var objectType = props.objectType,
          subjectId = props.subjectId;

      var associationMap = _EngagementAssociationsStore.default.get((0, _immutable.Map)({
        objectType: objectType,
        subjectId: Number(subjectId)
      }));

      return associationMap || (0, _immutable.Map)();
    }
  },
  defaultAssociations: _DefaultAssociationsDependency.default
};
var propTypes = {
  associationsMap: _propTypes.default.instanceOf(_immutable.Map).isRequired,
  defaultAssociations: _reactImmutableProptypes.default.map,
  associations: _propTypes.default.instanceOf(_immutable.Map),
  objectType: _ProfileObjectTypesType.default.isRequired,
  subjectId: _propTypes.default.string.isRequired,
  LocalSettings: _propTypes.default.object.isRequired,
  gates: _propTypes.default.shape({
    get: _propTypes.default.func.isRequired
  }),
  interaction: _propTypes.default.instanceOf(_InteractionRecord.default).isRequired,
  descriptor: _propTypes.default.instanceOf(_InteractionDescriptorRecord.default).isRequired,
  onCancel: _propTypes.default.func.isRequired,
  onSave: _propTypes.default.func.isRequired
};
var defaultProps = {
  gates: (0, _immutable.Set)()
};

function InteractionWithDefaultContent(InteractionComponent, interactionType) {
  var InteractionWithDefaultContentComponent =
  /*#__PURE__*/
  function (_Component) {
    (0, _inherits2.default)(InteractionWithDefaultContentComponent, _Component);

    function InteractionWithDefaultContentComponent(props) {
      var _this;

      (0, _classCallCheck2.default)(this, InteractionWithDefaultContentComponent);
      _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(InteractionWithDefaultContentComponent).call(this, props));
      (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
      _this.shouldExclusivelyUseLocalStorageAssociations = _this.shouldExclusivelyUseLocalStorageAssociations.bind((0, _assertThisInitialized2.default)(_this));
      var localInteraction = new _LocalInteraction.default(interactionType, props.objectType, props.subjectId, props.LocalSettings);
      _this.localInteraction = localInteraction;
      _this.state = {
        mergedDefaultAssociations: false,
        interaction: props.interaction || new _InteractionRecord.default(),
        attachments: (0, _immutable.List)()
      };
      return _this;
    }

    (0, _createClass2.default)(InteractionWithDefaultContentComponent, [{
      key: "componentWillMount",
      value: function componentWillMount() {
        var _this$props = this.props,
            defaultAssociations = _this$props.defaultAssociations,
            gates = _this$props.gates;
        var restoredInteraction = this.handleRestoreLocalInteraction();

        if (defaultAssociations) {
          this.handleMergeDefaultAssociations(defaultAssociations);
          this.setState({
            mergedDefaultAssociations: true
          });
          return;
        }

        if (this.props.associations) {
          this.handleMergeDefaultAssociations(this.props.associations);
          return;
        }

        var restoredAssociations = restoredInteraction && restoredInteraction.interaction && restoredInteraction.interaction.associations;

        if (gates.get('CRM:RestoreLocalAssociations') && restoredAssociations) {
          this.handleMergeDefaultAssociations(restoredAssociations);

          if (this.shouldExclusivelyUseLocalStorageAssociations(restoredAssociations)) {
            this.setState({
              mergedDefaultAssociations: true
            });
          }

          return;
        }
      }
    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        if (nextProps.defaultAssociations && !this.state.mergedDefaultAssociations) {
          this.handleMergeDefaultAssociations(nextProps.defaultAssociations);
          this.setState({
            mergedDefaultAssociations: true
          });
        }
      } // Some local storage data might contain only ownerIds. If this is the case, we want to still use
      // the assocaitions DefaultAssociationsDependency provides. If the local storage contains contactIds,
      // companyIds, dealIds, or ticketIds then we can ignore the DefaultAssociationsDependency.

    }, {
      key: "shouldExclusivelyUseLocalStorageAssociations",
      value: function shouldExclusivelyUseLocalStorageAssociations(associations) {
        ['contactIds', 'dealIds', 'companyIds', 'ticketIds'].any(function (key) {
          return associations.get(key) && associations.get(key).size;
        });
      }
    }, {
      key: "handleRestoreLocalInteraction",
      value: function handleRestoreLocalInteraction() {
        var localTransforms = this.props.descriptor.localTransforms;
        var restored = (0, _Interactions.restoreLocalInteraction)(this.localInteraction, localTransforms);

        if (restored != null) {
          var interaction = restored.interaction,
              attachments = restored.attachments;
          this.setState({
            interaction: interaction,
            attachments: attachments
          });
        }

        return restored;
      }
    }, {
      key: "handleMergeDefaultAssociations",
      value: function handleMergeDefaultAssociations(defaultAssociations) {
        var _this$props2 = this.props,
            objectType = _this$props2.objectType,
            subjectId = _this$props2.subjectId,
            gates = _this$props2.gates;

        if (gates && gates.get('CRM:DefaultAssociationsV2')) {
          EngagementAssociationActions.mergeAndUpdateAssociations(objectType, Number(subjectId), defaultAssociations, (0, _immutable.Map)());
        } else {
          EngagementAssociationActions.mergeAssociations(objectType, Number(subjectId), defaultAssociations, (0, _immutable.Map)());
        }
      }
    }, {
      key: "handleResetComponentState",
      value: function handleResetComponentState() {
        var defaultAssociations = this.props.defaultAssociations;
        this.localInteraction.reset();
        this.handleResetAssociations();

        if (defaultAssociations) {
          this.handleMergeDefaultAssociations(defaultAssociations);
        }

        this.setState({
          interaction: new _InteractionRecord.default(),
          attachments: (0, _immutable.List)()
        });
      }
    }, {
      key: "handleResetAssociations",
      value: function handleResetAssociations() {
        var _this$props3 = this.props,
            objectType = _this$props3.objectType,
            subjectId = _this$props3.subjectId;
        EngagementAssociationActions.clearAssociations(objectType, Number(subjectId));
      }
    }, {
      key: "handleReset",
      value: function handleReset() {
        this.handleResetComponentState();
        this.props.onCancel();
      }
    }, {
      key: "handleSave",
      value: function handleSave(interactionRecord, engagement) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        this.handleResetComponentState();
        this.props.onSave(interactionRecord, engagement, options);
      }
    }, {
      key: "render",
      value: function render() {
        return _react.default.createElement(InteractionComponent, (0, _extends2.default)({}, this.props, {
          associations: this.props.associationsMap,
          localInteraction: this.localInteraction,
          interaction: this.state.interaction,
          attachments: this.state.attachments,
          onCancel: this.handleReset,
          onSave: this.handleSave
        }));
      }
    }]);
    return InteractionWithDefaultContentComponent;
  }(_react.Component);

  InteractionWithDefaultContentComponent.propTypes = propTypes;
  InteractionWithDefaultContentComponent.defaultProps = defaultProps;
  return (0, _generalStore.connect)(dependencies)(InteractionWithDefaultContentComponent);
}

var _default = InteractionWithDefaultContent;
exports.default = _default;
module.exports = exports.default;